class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        code: record?.code,
        companyservice: record?.companyservice,
        schedule: record?.schedule,
        max_user_usage: record?.max_user_usage,
        max_global_usage: record?.max_global_usage,
        amount: record?.amount,
        active: record?.active,
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        title: record?.code,
      }
    }
  }

  static getEmptyFormHandler() {
    return function getEmptyForm() {
      return {
        active: true,
      }
    }
  }

  static formToRecordHandler() {
    return function formToRecord(values) {
      return {
        code: values?.code,
        companyservice: values?.companyservice,
        schedule: values?.schedule,
        max_user_usage: values?.max_user_usage,
        max_global_usage: values?.max_global_usage,
        amount: values?.amount,
        active: values?.active,
      }
    }
  }
}

export default Callbacks
